import React, { Component } from 'react'

class Blog extends Component {
  render() {
    return (
      <div>
        <h1>Coming soon</h1>
      </div>
    )
  }
}

export default Blog